import React, { useState, useRef, useEffect } from "react";
import SlideShow from "../components/SlideShow";
import imageCollection from "../data/homeSlideShow_Data";
import Exhibitions from "../components/Exhibitions";
import upcomingExhibitions from "../data/upcomingExhibitions_Data";
import { Helmet } from "react-helmet-async";
import MailerLiteForm from "../components/MailerLiteForm";
import heroImage from "../images/recent/1toafBK2023.webp";

function Home() {
  const [heroVisible, setHeroVisible] = useState(false);
  const scrollerRef = useRef(null);

  // Show the fixed background while the hero section is in view;
  // hide it once the user scrolls into the main content card.
  useEffect(() => {
    const target = scrollerRef.current;
    if (!target) return;
    const obs = new IntersectionObserver(
      ([entry]) => setHeroVisible(entry.isIntersecting),
      { threshold: 0 }
    );
    obs.observe(target);
    return () => obs.disconnect();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Tyrone Layne, Painter</title>
        <meta property='og:title' content='Tyrone Layne, Painter' />
        <meta
          property='og:description'
          content='New Zealand Contemporary Artist Tyrone Layne based in Sydney, Australia. Painter of peoplescapes — observational scenes of contemporary city life.'
        />
        <meta property='og:image' content={imageCollection[0].image} />
        <meta property='og:type' content='website' />
        <link rel='canonical' href='https://tyronelayne.com' />
        {/* Preload the hero background so it's fetched before JS applies the backgroundImage style */}
        <link rel='preload' as='image' href={heroImage} fetchpriority='high' />
      </Helmet>

      {/* -------- FIXED BACKGROUND --------
          Rendered as <img> so the browser discovers and fetches it before
          JS sets a backgroundImage — making it a proper LCP candidate. */}
      <img
        src={heroImage}
        alt=''
        aria-hidden='true'
        fetchpriority='high'
        decoding='async'
        style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100vw', height: '100vh',
          objectFit: 'cover',
          objectPosition: 'center',
          zIndex: 0,
          opacity: heroVisible ? 1 : 0,
          transition: 'opacity 400ms ease',
          pointerEvents: 'none',
        }}
      />

      {/* -------- HERO SECTION --------
          Transparent 100vh gap — the fixed background shows through.
          Title sits centered over the image and scrolls naturally
          upward as the user scrolls into the main content card. */}
      <div className='vrPxScroller homeHeroScroller' ref={scrollerRef}>
        <section className='vrPxSection'>
          <div className='homeHeroGap'>
            <div className='homeHeroTitleBlock'>
              <h1 className='homeHeroName'>TYRONE LAYNE</h1>
              <h1 className='homeHeroPainter'>PAINTER</h1>
            </div>
            <div className='vrPxScrollHint'>
              <span className='vrPxScrollHintText'>Scroll down</span>
              <span className='vrPxScrollHintArrow' aria-hidden='true'>
                &#x2193;
              </span>
            </div>
          </div>
        </section>
      </div>

      {/* -------- MAIN CONTENT CARD --------
          White panel that slides up over the hero background.
          Contains the slideshow and all existing home content. */}
      <div className='homeMainCard'>
        <SlideShow
          slides={imageCollection}
          slideShowName='recentWorks'
          startingIndex={0}
          scrollOffset={-40}
        />
        <div style={{ height: "3rem" }} />
        <Exhibitions exhibitions={upcomingExhibitions} />
        <div style={{ height: "3rem" }} />

        <div style={{ maxWidth: "440px", margin: "2.5rem auto 0", padding: "0 1rem" }}>
          <MailerLiteForm className='newsletterFormWrap' />
        </div>
        <div style={{ height: "3rem" }} />
      </div>
    </div>
  );
}

export default Home;
